var items = {
  "block.minecraft.air": "агаар",
  "block.minecraft.stone": "чулуу",
  "block.minecraft.granite": "боржин",
  "block.minecraft.polished_granite": "өнгөлсөн боржин",
  "block.minecraft.diorite": "диорит",
  "block.minecraft.polished_diorite": "өнгөлсөн диорит",
  "block.minecraft.andesite": "андезит",
  "block.minecraft.polished_andesite": "өнгөлсөн андезит",
  "block.minecraft.grass_block": "өвстэй хөрс",
  "block.minecraft.dirt": "шороо",
  "block.minecraft.coarse_dirt": "чулуутай шороо",
  "block.minecraft.podzol": "шилмүүст хөрс",
  "block.minecraft.crimson_nylium": "нөжит хөрс",
  "block.minecraft.warped_nylium": "гажуудсан хөрс",
  "block.minecraft.cobblestone": "хагархай чулуу",
  "block.minecraft.oak_planks": "царс модон банз",
  "block.minecraft.spruce_planks": "гацуур модон банз",
  "block.minecraft.birch_planks": "хус модон банз",
  "block.minecraft.jungle_planks": "ширэнгэн ойн модон банз",
  "block.minecraft.acacia_planks": "хуайс модон банз",
  "block.minecraft.dark_oak_planks": "хар царс модон банз",
  "block.minecraft.crimson_planks": "нөжит модон банз",
  "block.minecraft.warped_planks": "гажуудсан модон банз",
  "block.minecraft.oak_sapling": "зулзаган царс мод",
  "block.minecraft.spruce_sapling": "зулзаган гацуур мод",
  "block.minecraft.birch_sapling": "зулзаган хус мод",
  "block.minecraft.jungle_sapling": "зулзаган ширэнгэн ойн мод",
  "block.minecraft.acacia_sapling": "зулзаган хуайс мод",
  "block.minecraft.dark_oak_sapling": "зулзаган хар царс мод",
  "block.minecraft.bedrock": "үндсэн чулуулаг",
  "block.minecraft.sand": "элс",
  "block.minecraft.red_sand": "улаан элс",
  "block.minecraft.gravel": "хайрга",
  "block.minecraft.gold_ore": "алтны хүдэр",
  "block.minecraft.iron_ore": "төмрийн хүдэр",
  "block.minecraft.coal_ore": "нүүрсны хүдэр",
  "block.minecraft.nether_gold_ore": "тамын алтны хүдэр",
  "block.minecraft.oak_log": "царс модон дүнз",
  "block.minecraft.spruce_log": "гацуур модон дүнз",
  "block.minecraft.birch_log": "хус модон дүнз",
  "block.minecraft.jungle_log": "ширэнгэн ойн модон дүнз",
  "block.minecraft.acacia_log": "хуайс модон дүнз",
  "block.minecraft.dark_oak_log": "хар царс модон дүнз",
  "block.minecraft.crimson_stem": "нөжит дүнз",
  "block.minecraft.warped_stem": "гажуудсан дүнз",
  "block.minecraft.stripped_oak_log": "холтослосон царс модон дүнз",
  "block.minecraft.stripped_spruce_log": "холтослосон гацуур модон дүнз",
  "block.minecraft.stripped_birch_log": "холтослосон хус модон дүнз",
  "block.minecraft.stripped_jungle_log": "холтослосон ширэнгэн ойн модон дүнз",
  "block.minecraft.stripped_acacia_log": "холтослосон хуайс модон дүнз",
  "block.minecraft.stripped_dark_oak_log": "холтослосон хар царс модон дүнз",
  "block.minecraft.stripped_crimson_stem": "холтослосон нөжит дүнз",
  "block.minecraft.stripped_warped_stem": "холтослосон гажуудсан дүнз",
  "block.minecraft.stripped_oak_wood": "холтослосон царс мод",
  "block.minecraft.stripped_spruce_wood": "холтослосон гацуур мод",
  "block.minecraft.stripped_birch_wood": "холтослосон хус мод",
  "block.minecraft.stripped_jungle_wood": "холтослосон ширэнгэн ойн мод",
  "block.minecraft.stripped_acacia_wood": "холтослосон хуайс мод",
  "block.minecraft.stripped_dark_oak_wood": "холтослосон хар царс мод",
  "block.minecraft.stripped_crimson_hyphae": "холтослосон нөжит мод",
  "block.minecraft.stripped_warped_hyphae": "холтослосон гажуудсан мод",
  "block.minecraft.oak_wood": "царс мод",
  "block.minecraft.spruce_wood": "гацуур мод",
  "block.minecraft.birch_wood": "хус мод",
  "block.minecraft.jungle_wood": "ширэнгэн ойн мод",
  "block.minecraft.acacia_wood": "хуайс мод",
  "block.minecraft.dark_oak_wood": "хар царс мод",
  "block.minecraft.crimson_hyphae": "нөжит мод",
  "block.minecraft.warped_hyphae": "гажуудсан мод",
  "block.minecraft.oak_leaves": "царс модны навч",
  "block.minecraft.spruce_leaves": "гацуур модны шилмүүс",
  "block.minecraft.birch_leaves": "хус модны навч",
  "block.minecraft.jungle_leaves": "ширэнгэн ойн модны навч",
  "block.minecraft.acacia_leaves": "хуайс модны навч",
  "block.minecraft.dark_oak_leaves": "хар царс модны навч",
  "block.minecraft.sponge": "хөвөн",
  "block.minecraft.wet_sponge": "нойтон хөвөн",
  "block.minecraft.glass": "шил",
  "block.minecraft.lapis_ore": "номин чулууны хүдэр",
  "block.minecraft.lapis_block": "номин чулуун блок",
  "block.minecraft.dispenser": "харвагч",
  "block.minecraft.sandstone": "элсэн чулуу",
  "block.minecraft.chiseled_sandstone": "сийлсэн элсэн чулуу",
  "block.minecraft.cut_sandstone": "өөлсөн элсэн чулуу",
  "block.minecraft.note_block": "хөгжим",
  "block.minecraft.powered_rail": "хүчжүүлсэн төмөр зам",
  "block.minecraft.detector_rail": "илрүүлэгч төмөр зам",
  "block.minecraft.sticky_piston": "наалдамхай түлхэгч",
  "block.minecraft.cobweb": "аалзны тор",
  "block.minecraft.grass": "өвс",
  "block.minecraft.fern": "ойм",
  "block.minecraft.dead_bush": "үхсэн бут",
  "block.minecraft.seagrass": "тэнгисийн өвс",
  "block.minecraft.sea_pickle": "тэнгисийн гэрлэн биет",
  "block.minecraft.piston": "түлхэгч",
  "block.minecraft.white_wool": "цагаан ноос",
  "block.minecraft.orange_wool": "улбар шар ноос",
  "block.minecraft.magenta_wool": "ягаан ноос",
  "block.minecraft.light_blue_wool": "цайвар цэнхэр ноос",
  "block.minecraft.yellow_wool": "шар ноос",
  "block.minecraft.lime_wool": "цайвар ногоон ноос",
  "block.minecraft.pink_wool": "цайвар ягаан ноос",
  "block.minecraft.gray_wool": "саарал ноос",
  "block.minecraft.light_gray_wool": "цайвар саарал ноос",
  "block.minecraft.cyan_wool": "цэнхэр ноос",
  "block.minecraft.purple_wool": "нил ягаан ноос",
  "block.minecraft.blue_wool": "хөх ноос",
  "block.minecraft.brown_wool": "бор ноос",
  "block.minecraft.green_wool": "ногоон ноос",
  "block.minecraft.red_wool": "улаан ноос",
  "block.minecraft.black_wool": "хар ноос",
  "block.minecraft.dandelion": "багваахай",
  "block.minecraft.poppy": "намуу",
  "block.minecraft.blue_orchid": "хөх цахирмаа",
  "block.minecraft.allium": "халиар",
  "block.minecraft.azure_bluet": "хонгорзул",
  "block.minecraft.red_tulip": "улаан алтанзул",
  "block.minecraft.orange_tulip": "улбар шар алтанзул",
  "block.minecraft.white_tulip": "цагаан алтанзул",
  "block.minecraft.pink_tulip": "ягаан алтанзул",
  "block.minecraft.oxeye_daisy": "хонин нүд",
  "block.minecraft.cornflower": "хөх хонгорзул",
  "block.minecraft.lily_of_the_valley": "хөндийн сараана",
  "block.minecraft.wither_rose": "витерийн сарнай",
  "block.minecraft.brown_mushroom": "бор мөөг",
  "block.minecraft.red_mushroom": "улаан мөөг",
  "block.minecraft.crimson_fungus": "нөжит мөөг",
  "block.minecraft.warped_fungus": "гажуудсан мөөг",
  "block.minecraft.crimson_roots": "нөжит ургамал",
  "block.minecraft.warped_roots": "гажуудсан ургамал",
  "block.minecraft.nether_sprouts": "тамын нахиа",
  "block.minecraft.weeping_vines": "уй гашууны ургамал",
  "block.minecraft.twisting_vines": "мушгиа ургамал",
  "block.minecraft.sugar_cane": "чихрийн нишингэ",
  "block.minecraft.kelp": "замаг",
  "block.minecraft.bamboo": "хулс",
  "block.minecraft.gold_block": "алтан блок",
  "block.minecraft.iron_block": "төмөр блок",
  "block.minecraft.oak_slab": "царс модон хавтан",
  "block.minecraft.spruce_slab": "гацуур модон хавтан",
  "block.minecraft.birch_slab": "хус модон хавтан",
  "block.minecraft.jungle_slab": "ширэнгэн ойн модон хавтан",
  "block.minecraft.acacia_slab": "хуайс модон хавтан",
  "block.minecraft.dark_oak_slab": "хар царс модон хавтан",
  "block.minecraft.crimson_slab": "нөжит модон хавтан",
  "block.minecraft.warped_slab": "гажуудсан модон хавтан",
  "block.minecraft.stone_slab": "чулуун хавтан",
  "block.minecraft.smooth_stone_slab": "гөлгөр чулуун хавтан",
  "block.minecraft.sandstone_slab": "элсэн чулуун хавтан",
  "block.minecraft.cut_sandstone_slab": "өөлсөн элсэн чулуун хавтан",
  "block.minecraft.petrified_oak_slab": "чулуужсан царс модон хавтан",
  "block.minecraft.cobblestone_slab": "хагархай чулуун хавтан",
  "block.minecraft.brick_slab": "тоосгон хавтан",
  "block.minecraft.stone_brick_slab": "чулуун тоосгон хавтан",
  "block.minecraft.nether_brick_slab": "тамын тоосгон хавтан",
  "block.minecraft.quartz_slab": "кварц хавтан",
  "block.minecraft.red_sandstone_slab": "улаан элсэн чулуун хавтан",
  "block.minecraft.cut_red_sandstone_slab": "өөлсөн улаан элсэн чулуун хавтан",
  "block.minecraft.purpur_slab": "пурпур хавтан",
  "block.minecraft.prismarine_slab": "присмарин хавтан",
  "block.minecraft.prismarine_brick_slab": "присмарин тоосгон хавтан",
  "block.minecraft.dark_prismarine_slab": "хар присмарин хавтан",
  "block.minecraft.smooth_quartz": "гөлгөр кварц блок",
  "block.minecraft.smooth_red_sandstone": "гөлгөр улаан элсэн чулуу",
  "block.minecraft.smooth_sandstone": "гөлгөр элсэн чулуу",
  "block.minecraft.smooth_stone": "гөлгөр чулуу",
  "block.minecraft.bricks": "тоосгон блок",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "номын тавиур",
  "block.minecraft.mossy_cobblestone": "хөвдтэй хагархай чулуу",
  "block.minecraft.obsidian": "хар шил",
  "block.minecraft.torch": "бамбар",
  "block.minecraft.end_rod": "ээндийн савх",
  "block.minecraft.chorus_plant": "дахилтат ургамал",
  "block.minecraft.chorus_flower": "дахилтат цэцэг",
  "block.minecraft.purpur_block": "пурпур блок",
  "block.minecraft.purpur_pillar": "пурпур багана",
  "block.minecraft.purpur_stairs": "пурпур шат",
  "block.minecraft.spawner": "төрүүлэгч",
  "block.minecraft.oak_stairs": "царс модон шат",
  "block.minecraft.chest": "авдар",
  "block.minecraft.diamond_ore": "алмаасын хүдэр",
  "block.minecraft.diamond_block": "алмаас эрдэнэн блок",
  "block.minecraft.crafting_table": "урлах ширээ",
  "block.minecraft.farmland": "хагалсан газар",
  "block.minecraft.furnace": "зуух",
  "block.minecraft.ladder": "босоо шат",
  "block.minecraft.rail": "төмөр зам",
  "block.minecraft.cobblestone_stairs": "хагархай чулуун шат",
  "block.minecraft.lever": "хөшүүрэг",
  "block.minecraft.stone_pressure_plate": "чулуун даралтын хавтан",
  "block.minecraft.oak_pressure_plate": "царс модон даралтын хавтан",
  "block.minecraft.spruce_pressure_plate": "гацуур модон даралтын хавтан",
  "block.minecraft.birch_pressure_plate": "хус модон даралтын хавтан",
  "block.minecraft.jungle_pressure_plate": "ширэнгэн ойн модон даралтын хавтан",
  "block.minecraft.acacia_pressure_plate": "хуайс модон даралтын хавтан",
  "block.minecraft.dark_oak_pressure_plate": "хар царс модон даралтын хавтан",
  "block.minecraft.crimson_pressure_plate": "нөжит модон даралтын хавтан",
  "block.minecraft.warped_pressure_plate": "гажуудсан модон даралтын хавтан",
  "block.minecraft.polished_blackstone_pressure_plate": "өнгөлсөн хар чулуун даралтын хавтан",
  "block.minecraft.redstone_ore": "редстоуны хүдэр",
  "block.minecraft.redstone_torch": "редстоун бамбар",
  "block.minecraft.snow": "цас",
  "block.minecraft.ice": "мөс",
  "block.minecraft.snow_block": "цасан блок",
  "block.minecraft.cactus": "кактус",
  "block.minecraft.clay": "шавар",
  "block.minecraft.jukebox": "пянз тоглуулагч",
  "block.minecraft.oak_fence": "царс модон хашаа",
  "block.minecraft.spruce_fence": "гацуур модон хашаа",
  "block.minecraft.birch_fence": "хус модон хашаа",
  "block.minecraft.jungle_fence": "ширэнгэн ойн модон хашаа",
  "block.minecraft.acacia_fence": "хуайс модон хашаа",
  "block.minecraft.dark_oak_fence": "хар царс модон хашаа",
  "block.minecraft.crimson_fence": "нөжит модон хашаа",
  "block.minecraft.warped_fence": "гажуудсан модон хашаа",
  "block.minecraft.pumpkin": "хулуу",
  "block.minecraft.carved_pumpkin": "сийлсэн хулуу",
  "block.minecraft.netherrack": "тамын чулуу",
  "block.minecraft.soul_sand": "сүнслэг элс",
  "block.minecraft.soul_soil": "сүнслэг хөрс",
  "block.minecraft.basalt": "базальт",
  "block.minecraft.polished_basalt": "өнгөлсөн базальт",
  "block.minecraft.soul_torch": "сүнслэг бамбар",
  "block.minecraft.glowstone": "гэрэлт чулуу",
  "block.minecraft.jack_o_lantern": "гэрэлт хулуу",
  "block.minecraft.oak_trapdoor": "царс модон сөхдөг хаалга",
  "block.minecraft.spruce_trapdoor": "гацуур модон сөхдөг хаалга",
  "block.minecraft.birch_trapdoor": "хус модон сөхдөг хаалга",
  "block.minecraft.jungle_trapdoor": "ширэнгэн ойн модон сөхдөг хаалга",
  "block.minecraft.acacia_trapdoor": "хуайс модон сөхдөг хаалга",
  "block.minecraft.dark_oak_trapdoor": "хар царс модон сөхдөг хаалга",
  "block.minecraft.crimson_trapdoor": "нөжит модон сөхдөг хаалга",
  "block.minecraft.warped_trapdoor": "гажуудсан модон сөхдөг хаалга",
  "block.minecraft.infested_stone": "язганах чулуу",
  "block.minecraft.infested_cobblestone": "язганах хагархай чулуу",
  "block.minecraft.infested_stone_bricks": "язганах чулуун тоосго",
  "block.minecraft.infested_mossy_stone_bricks": "язганах хөвдтэй хагархай чулуу",
  "block.minecraft.infested_cracked_stone_bricks": "язганах хөвдтэй чулуун тоосго",
  "block.minecraft.infested_chiseled_stone_bricks": "язганах сийлсэн чулуун тоосго",
  "block.minecraft.stone_bricks": "чулуун тоосго",
  "block.minecraft.mossy_stone_bricks": "хөвдтэй чулуун тоосго",
  "block.minecraft.cracked_stone_bricks": "хагарсан чулуун тоосго",
  "block.minecraft.chiseled_stone_bricks": "сийлсэн чулуун тоосго",
  "block.minecraft.brown_mushroom_block": "бор мөөгөн блок",
  "block.minecraft.red_mushroom_block": "улаан мөөгөн блок",
  "block.minecraft.mushroom_stem": "мөөгний иш",
  "block.minecraft.iron_bars": "төмөр тор",
  "block.minecraft.chain": "гинж",
  "block.minecraft.glass_pane": "шилэн хавтан",
  "block.minecraft.melon": "тарвас",
  "block.minecraft.vine": "ороонго ургамал",
  "block.minecraft.oak_fence_gate": "царс модон хашааны хаалга",
  "block.minecraft.spruce_fence_gate": "гацуур модон хашааны хаалга",
  "block.minecraft.birch_fence_gate": "хус модон хашааны хаалга",
  "block.minecraft.jungle_fence_gate": "ширэнгэн ойн модон хашааны хаалга",
  "block.minecraft.acacia_fence_gate": "хуайс модон хашааны хаалга",
  "block.minecraft.dark_oak_fence_gate": "хар царс модон хашааны хаалга",
  "block.minecraft.crimson_fence_gate": "нөжит модон хашааны хаалга",
  "block.minecraft.warped_fence_gate": "гажуудсан модон хашааны хаалга",
  "block.minecraft.brick_stairs": "тоосгон шат",
  "block.minecraft.stone_brick_stairs": "чулуун тоосгон шат",
  "block.minecraft.mycelium": "мөөгний хөрс",
  "block.minecraft.lily_pad": "сарааны дэлбээ",
  "block.minecraft.nether_bricks": "тамын тоосго",
  "block.minecraft.cracked_nether_bricks": "хагархай тамын тоосго",
  "block.minecraft.chiseled_nether_bricks": "сийлбэртэй тамын тоосго",
  "block.minecraft.nether_brick_fence": "тамын тоосгон хашаа",
  "block.minecraft.nether_brick_stairs": "тамын тоосгон шат",
  "block.minecraft.enchanting_table": "ид шидийн ширээ",
  "block.minecraft.end_portal_frame": "ээндийн хаалганы хүрээ",
  "block.minecraft.end_stone": "ээндийн чулуу",
  "block.minecraft.end_stone_bricks": "ээндийн чулуун тоосго",
  "block.minecraft.dragon_egg": "луугийн өндөг",
  "block.minecraft.redstone_lamp": "редстоун гэрэл",
  "block.minecraft.sandstone_stairs": "элсэн чулуун шат",
  "block.minecraft.emerald_ore": "маргадын хүдэр",
  "block.minecraft.ender_chest": "ээндэрийн авдар",
  "block.minecraft.tripwire_hook": "тээглүүр утасны дэгээ",
  "block.minecraft.emerald_block": "маргад блок",
  "block.minecraft.spruce_stairs": "гацуур модон шат",
  "block.minecraft.birch_stairs": "хус модон шат",
  "block.minecraft.jungle_stairs": "ширэнгэн ойн модон шат",
  "block.minecraft.crimson_stairs": "нөжит модон шат",
  "block.minecraft.warped_stairs": "гажуудсан модон шат",
  "block.minecraft.command_block": "тушаалын блок",
  "block.minecraft.beacon": "гэрэл цацруулагч",
  "block.minecraft.cobblestone_wall": "хагархай чулуун хана",
  "block.minecraft.mossy_cobblestone_wall": "хөвдтэй хагархай чулуун хана",
  "block.minecraft.brick_wall": "тоосгон хана",
  "block.minecraft.prismarine_wall": "присмарин хана",
  "block.minecraft.red_sandstone_wall": "улаан элсэн чулуун хана",
  "block.minecraft.mossy_stone_brick_wall": "хөвдтэй чулуун тоосгон хана",
  "block.minecraft.granite_wall": "боржин хана",
  "block.minecraft.stone_brick_wall": "чулуун тоосгон хана",
  "block.minecraft.nether_brick_wall": "тамын тоосгон хана",
  "block.minecraft.andesite_wall": "андезит хана",
  "block.minecraft.red_nether_brick_wall": "улаан тамын тоосгон хана",
  "block.minecraft.sandstone_wall": "элсэн чулуун хана",
  "block.minecraft.end_stone_brick_wall": "ээндийн чулуун тоосгон хана",
  "block.minecraft.diorite_wall": "диорит хана",
  "block.minecraft.blackstone_wall": "хар чулуун хана",
  "block.minecraft.polished_blackstone_wall": "өнгөлсөн хар чулуун хана",
  "block.minecraft.polished_blackstone_brick_wall": "өнгөлсөн хар чулуун тоосгон хана",
  "block.minecraft.stone_button": "чулуун товч",
  "block.minecraft.oak_button": "царс модон товч",
  "block.minecraft.spruce_button": "гацуур модон товч",
  "block.minecraft.birch_button": "хус модон товч",
  "block.minecraft.jungle_button": "ширэнгэн ойн модон товч",
  "block.minecraft.acacia_button": "хуайс модон товч",
  "block.minecraft.dark_oak_button": "хар царс модон товч",
  "block.minecraft.crimson_button": "нөжит модон товч",
  "block.minecraft.warped_button": "гажуудсан модон товч",
  "block.minecraft.polished_blackstone_button": "өнгөлсөн хар чулуун товч",
  "block.minecraft.anvil": "дөш",
  "block.minecraft.chipped_anvil": "эмтэрсэн дөш",
  "block.minecraft.damaged_anvil": "эвдэрсэн дөш",
  "block.minecraft.trapped_chest": "урхитай авдар",
  "block.minecraft.light_weighted_pressure_plate": "хөнгөн жингийн даралтын хавтан",
  "block.minecraft.heavy_weighted_pressure_plate": "хүнд жингийн даралтын хавтан",
  "block.minecraft.daylight_detector": "нарны гэрэл мэдрэгч",
  "block.minecraft.redstone_block": "редстоун блок",
  "block.minecraft.nether_quartz_ore": "кварцын хүдэр",
  "block.minecraft.hopper": "гулгуулагч",
  "block.minecraft.chiseled_quartz_block": "сийлсэн кварц блок",
  "block.minecraft.quartz_block": "кварц блок",
  "block.minecraft.quartz_bricks": "кварц тоосго",
  "block.minecraft.quartz_pillar": "кварц багана",
  "block.minecraft.quartz_stairs": "кварц шат",
  "block.minecraft.activator_rail": "идэвхжүүлэгч төмөр зам",
  "block.minecraft.dropper": "унагагч",
  "block.minecraft.white_terracotta": "цагаан хатуу шавар",
  "block.minecraft.orange_terracotta": "улбар шар хатуу шавар",
  "block.minecraft.magenta_terracotta": "ягаан хатуу шавар",
  "block.minecraft.light_blue_terracotta": "цайвар цэнхэр хатуу шавар",
  "block.minecraft.yellow_terracotta": "шар хатуу шавар",
  "block.minecraft.lime_terracotta": "цайвар ногоон хатуу шавар",
  "block.minecraft.pink_terracotta": "цайвар ягаан хатуу шавар",
  "block.minecraft.gray_terracotta": "саарал хатуу шавар",
  "block.minecraft.light_gray_terracotta": "цайвар саарал хатуу шавар",
  "block.minecraft.cyan_terracotta": "цэнхэр хатуу шавар",
  "block.minecraft.purple_terracotta": "нил ягаан хатуу шавар",
  "block.minecraft.blue_terracotta": "хөх хатуу шавар",
  "block.minecraft.brown_terracotta": "бор хатуу шавар",
  "block.minecraft.green_terracotta": "ногоон хатуу шавар",
  "block.minecraft.red_terracotta": "улаан хатуу шавар",
  "block.minecraft.black_terracotta": "хар хатуу шавар",
  "block.minecraft.barrier": "хаалт",
  "block.minecraft.iron_trapdoor": "төмөр сөхдөг хаалга",
  "block.minecraft.hay_block": "бухал өвс",
  "block.minecraft.white_carpet": "цагаан хивс",
  "block.minecraft.orange_carpet": "улбар шар хивс",
  "block.minecraft.magenta_carpet": "ягаан хивс",
  "block.minecraft.light_blue_carpet": "цайвар цэнхэр хивс",
  "block.minecraft.yellow_carpet": "шар хивс",
  "block.minecraft.lime_carpet": "цайвар ногоон хивс",
  "block.minecraft.pink_carpet": "цайвар ягаан хивс",
  "block.minecraft.gray_carpet": "саарал хивс",
  "block.minecraft.light_gray_carpet": "цайвар саарал хивс",
  "block.minecraft.cyan_carpet": "цэнхэр хивс",
  "block.minecraft.purple_carpet": "нил ягаан хивс",
  "block.minecraft.blue_carpet": "хөх хивс",
  "block.minecraft.brown_carpet": "бор хивс",
  "block.minecraft.green_carpet": "ногоон хивс",
  "block.minecraft.red_carpet": "улаан хивс",
  "block.minecraft.black_carpet": "хар хивс",
  "block.minecraft.terracotta": "хатуу шавар",
  "block.minecraft.coal_block": "нүүрсэн блок",
  "block.minecraft.packed_ice": "нягт мөс",
  "block.minecraft.acacia_stairs": "хуайс модон шат",
  "block.minecraft.dark_oak_stairs": "хар царс модон шат",
  "block.minecraft.slime_block": "салс блок",
  "block.minecraft.grass_path": "өвсөн зам",
  "block.minecraft.sunflower": "наранцэцэг",
  "block.minecraft.lilac": "голт бор",
  "block.minecraft.rose_bush": "сарнайн бут",
  "block.minecraft.peony": "цээнэ",
  "block.minecraft.tall_grass": "өндөр өвс",
  "block.minecraft.large_fern": "том ойм",
  "block.minecraft.white_stained_glass": "цагаан будагтай шил",
  "block.minecraft.orange_stained_glass": "улбар шар будагтай шил",
  "block.minecraft.magenta_stained_glass": "ягаан будагтай шил",
  "block.minecraft.light_blue_stained_glass": "цайвар цэнхэр будагтай шил",
  "block.minecraft.yellow_stained_glass": "шар будагтай шил",
  "block.minecraft.lime_stained_glass": "цайвар ногоон будагтай шил",
  "block.minecraft.pink_stained_glass": "цайвар ягаан будагтай шил",
  "block.minecraft.gray_stained_glass": "саарал будагтай шил",
  "block.minecraft.light_gray_stained_glass": "цайвар саарал будагтай шил",
  "block.minecraft.cyan_stained_glass": "цэнхэр будагтай шил",
  "block.minecraft.purple_stained_glass": "нил ягаан будагтай шил",
  "block.minecraft.blue_stained_glass": "хөх будагтай шил",
  "block.minecraft.brown_stained_glass": "бор будагтай шил",
  "block.minecraft.green_stained_glass": "ногоон будагтай шил",
  "block.minecraft.red_stained_glass": "улаан будагтай шил",
  "block.minecraft.black_stained_glass": "хар будагтай шил",
  "block.minecraft.white_stained_glass_pane": "цагаан будагтай шилэн хавтан",
  "block.minecraft.orange_stained_glass_pane": "улбар шар будагтай шилэн хавтан",
  "block.minecraft.magenta_stained_glass_pane": "ягаан будагтай шилэн хавтан",
  "block.minecraft.light_blue_stained_glass_pane": "цайвар цэнхэр будагтай шилэн хавтан",
  "block.minecraft.yellow_stained_glass_pane": "шар будагтай шилэн хавтан",
  "block.minecraft.lime_stained_glass_pane": "цайвар ногоон будагтай шилэн хавтан",
  "block.minecraft.pink_stained_glass_pane": "цайвар ягаан будагтай шилэн хавтан",
  "block.minecraft.gray_stained_glass_pane": "саарал будагтай шилэн хавтан",
  "block.minecraft.light_gray_stained_glass_pane": "цайвар саарал будагтай шилэн хавтан",
  "block.minecraft.cyan_stained_glass_pane": "цэнхэр будагтай шилэн хавтан",
  "block.minecraft.purple_stained_glass_pane": "нил ягаан будагтай шилэн хавтан",
  "block.minecraft.blue_stained_glass_pane": "хөх будагтай шилэн хавтан",
  "block.minecraft.brown_stained_glass_pane": "бор будагтай шилэн хавтан",
  "block.minecraft.green_stained_glass_pane": "ногоон будагтай шилэн хавтан",
  "block.minecraft.red_stained_glass_pane": "улаан будагтай шилэн хавтан",
  "block.minecraft.black_stained_glass_pane": "хар будагтай шилэн хавтан",
  "block.minecraft.prismarine": "присмарин",
  "block.minecraft.prismarine_bricks": "присмарин тоосго",
  "block.minecraft.dark_prismarine": "хар присмарин",
  "block.minecraft.prismarine_stairs": "присмарин шат",
  "block.minecraft.prismarine_brick_stairs": "присмарин тоосгон шат",
  "block.minecraft.dark_prismarine_stairs": "хар присмарин шат",
  "block.minecraft.sea_lantern": "тэнгисийн дэнлүү",
  "block.minecraft.red_sandstone": "улаан элсэн чулуу",
  "block.minecraft.chiseled_red_sandstone": "сийлсэн улаан элсэн чулуу",
  "block.minecraft.cut_red_sandstone": "өөлсөн улаан элсэн чулуу",
  "block.minecraft.red_sandstone_stairs": "улаан элсэн чулуун шат",
  "block.minecraft.repeating_command_block": "давталттай тушаалын блок",
  "block.minecraft.chain_command_block": "гинжин тушаалын блок",
  "block.minecraft.magma_block": "хайлмагтай чулуу",
  "block.minecraft.nether_wart_block": "тамын үүн блок",
  "block.minecraft.warped_wart_block": "гажуудсан үүн блок",
  "block.minecraft.red_nether_bricks": "улаан тамын тоосго",
  "block.minecraft.bone_block": "ясан блок",
  "block.minecraft.structure_void": "байгууламжийн хоосон",
  "block.minecraft.observer": "ажиглагч",
  "block.minecraft.shulker_box": "шалкер хайрцаг",
  "block.minecraft.white_shulker_box": "цагаан шалкер хайрцаг",
  "block.minecraft.orange_shulker_box": "улбар шар шалкер хайрцаг",
  "block.minecraft.magenta_shulker_box": "ягаан шалкер хайрцаг",
  "block.minecraft.light_blue_shulker_box": "цайвар цэнхэр шалкер хайрцаг",
  "block.minecraft.yellow_shulker_box": "шар шалкер хайрцаг",
  "block.minecraft.lime_shulker_box": "цайвар ногоон шалкер хайрцаг",
  "block.minecraft.pink_shulker_box": "цайвар ягаан шалкер хайрцаг",
  "block.minecraft.gray_shulker_box": "саарал шалкер хайрцаг",
  "block.minecraft.light_gray_shulker_box": "цайвар саарал шалкер хайрцаг",
  "block.minecraft.cyan_shulker_box": "цэнхэр шалкер хайрцаг",
  "block.minecraft.purple_shulker_box": "нил ягаан шалкер хайрцаг",
  "block.minecraft.blue_shulker_box": "хөх шалкер хайрцаг",
  "block.minecraft.brown_shulker_box": "бор шалкер хайрцаг",
  "block.minecraft.green_shulker_box": "ногоон шалкер хайрцаг",
  "block.minecraft.red_shulker_box": "улаан шалкер хайрцаг",
  "block.minecraft.black_shulker_box": "хар шалкер хайрцаг",
  "block.minecraft.white_glazed_terracotta": "цагаан хээтэй шавар",
  "block.minecraft.orange_glazed_terracotta": "улбар шар хээтэй шавар",
  "block.minecraft.magenta_glazed_terracotta": "ягаан хээтэй шавар",
  "block.minecraft.light_blue_glazed_terracotta": "цайвар цэнхэр хээтэй шавар",
  "block.minecraft.yellow_glazed_terracotta": "шар хээтэй шавар",
  "block.minecraft.lime_glazed_terracotta": "цайвар ногоон хээтэй шавар",
  "block.minecraft.pink_glazed_terracotta": "цайвар ягаан хээтэй шавар",
  "block.minecraft.gray_glazed_terracotta": "саарал хээтэй шавар",
  "block.minecraft.light_gray_glazed_terracotta": "цайвар саарал хээтэй шавар",
  "block.minecraft.cyan_glazed_terracotta": "цэнхэр хээтэй шавар",
  "block.minecraft.purple_glazed_terracotta": "нил ягаан хээтэй шавар",
  "block.minecraft.blue_glazed_terracotta": "хөх хээтэй шавар",
  "block.minecraft.brown_glazed_terracotta": "бор хээтэй шавар",
  "block.minecraft.green_glazed_terracotta": "ногоон хээтэй шавар",
  "block.minecraft.red_glazed_terracotta": "улаан хээтэй шавар",
  "block.minecraft.black_glazed_terracotta": "хар хээтэй шавар",
  "block.minecraft.white_concrete": "цагаан бетон",
  "block.minecraft.orange_concrete": "улбар шар бетон",
  "block.minecraft.magenta_concrete": "ягаан бетон",
  "block.minecraft.light_blue_concrete": "цайвар цэнхэр бетон",
  "block.minecraft.yellow_concrete": "шар бетон",
  "block.minecraft.lime_concrete": "цайвар ногоон бетон",
  "block.minecraft.pink_concrete": "цайвар ягаан бетон",
  "block.minecraft.gray_concrete": "саарал бетон",
  "block.minecraft.light_gray_concrete": "цайвар саарал бетон",
  "block.minecraft.cyan_concrete": "цэнхэр бетон",
  "block.minecraft.purple_concrete": "нил ягаан бетон",
  "block.minecraft.blue_concrete": "хөх бетон",
  "block.minecraft.brown_concrete": "бор бетон",
  "block.minecraft.green_concrete": "ногоон бетон",
  "block.minecraft.red_concrete": "улаан бетон",
  "block.minecraft.black_concrete": "хар бетон",
  "block.minecraft.white_concrete_powder": "цагаан нунтаг бетон",
  "block.minecraft.orange_concrete_powder": "улбар шар нунтаг бетон",
  "block.minecraft.magenta_concrete_powder": "ягаан нунтаг бетон",
  "block.minecraft.light_blue_concrete_powder": "цайвар цэнхэр нунтаг бетон",
  "block.minecraft.yellow_concrete_powder": "шар нунтаг бетон",
  "block.minecraft.lime_concrete_powder": "цайвар ногоон нунтаг бетон",
  "block.minecraft.pink_concrete_powder": "цайвар ягаан нунтаг бетон",
  "block.minecraft.gray_concrete_powder": "саарал нунтаг бетон",
  "block.minecraft.light_gray_concrete_powder": "цайвар саарал нунтаг бетон",
  "block.minecraft.cyan_concrete_powder": "цэнхэр нунтаг бетон",
  "block.minecraft.purple_concrete_powder": "нил ягаан нунтаг бетон",
  "block.minecraft.blue_concrete_powder": "хөх нунтаг бетон",
  "block.minecraft.brown_concrete_powder": "бор нунтаг бетон",
  "block.minecraft.green_concrete_powder": "ногоон нунтаг бетон",
  "block.minecraft.red_concrete_powder": "улаан нунтаг бетон",
  "block.minecraft.black_concrete_powder": "хар нунтаг бетон",
  "block.minecraft.turtle_egg": "яст мэлхийн өндөг",
  "block.minecraft.dead_tube_coral_block": "үхсэн хоолой шүрэн блок",
  "block.minecraft.dead_brain_coral_block": "үхсэн угалзарсан шүрэн блок",
  "block.minecraft.dead_bubble_coral_block": "үхсэн бөмбөлөг шүрэн блок",
  "block.minecraft.dead_fire_coral_block": "үхсэн гал шүрэн блок",
  "block.minecraft.dead_horn_coral_block": "үхсэн эвэр шүрэн блок",
  "block.minecraft.tube_coral_block": "хоолой шүрэн блок",
  "block.minecraft.brain_coral_block": "угалзарсан шүрэн блок",
  "block.minecraft.bubble_coral_block": "бөмбөлөг шүрэн блок",
  "block.minecraft.fire_coral_block": "гал шүрэн блок",
  "block.minecraft.horn_coral_block": "эвэр шүрэн блок",
  "block.minecraft.tube_coral": "хоолой шүр",
  "block.minecraft.brain_coral": "угалзарсан шүр",
  "block.minecraft.bubble_coral": "бөмбөлөг шүр",
  "block.minecraft.fire_coral": "гал шүр",
  "block.minecraft.horn_coral": "эвэр шүр",
  "block.minecraft.dead_brain_coral": "үхсэн угалзарсан шүр",
  "block.minecraft.dead_bubble_coral": "үхсэн бөмбөлөг шүр",
  "block.minecraft.dead_fire_coral": "үхсэн гал шүр",
  "block.minecraft.dead_horn_coral": "үхсэн эвэр шүр",
  "block.minecraft.dead_tube_coral": "үхсэн хоолой шүр",
  "block.minecraft.tube_coral_fan": "хоолой шүрэн дэвүүр",
  "block.minecraft.brain_coral_fan": "угалзарсан шүрэн дэвүүр",
  "block.minecraft.bubble_coral_fan": "бөмбөлөг шүрэн дэвүүр",
  "block.minecraft.fire_coral_fan": "гал шүрэн дэвүүр",
  "block.minecraft.horn_coral_fan": "эвэр шүрэн дэвүүр",
  "block.minecraft.dead_tube_coral_fan": "үхсэн хоолой шүрэн дэвүүр",
  "block.minecraft.dead_brain_coral_fan": "үхсэн угалзарсан шүрэн дэвүүр",
  "block.minecraft.dead_bubble_coral_fan": "үхсэн бөмбөлөг шүрэн дэвүүр",
  "block.minecraft.dead_fire_coral_fan": "үхсэн гал шүрэн дэвүүр",
  "block.minecraft.dead_horn_coral_fan": "үхсэн эвэр шүрэн дэвүүр",
  "block.minecraft.blue_ice": "хөх мөс",
  "block.minecraft.conduit": "далайн хүчний ундарга",
  "block.minecraft.polished_granite_stairs": "өнгөлсөн боржин шат",
  "block.minecraft.smooth_red_sandstone_stairs": "гөлгөр улаан элсэн чулуун шат",
  "block.minecraft.mossy_stone_brick_stairs": "хөвдтэй чулуун тоосгон шат",
  "block.minecraft.polished_diorite_stairs": "өнгөлсөн диорит шат",
  "block.minecraft.mossy_cobblestone_stairs": "хөвдтэй хагархай чулуун шат",
  "block.minecraft.end_stone_brick_stairs": "ээндийн чулуун тоосгон шат",
  "block.minecraft.stone_stairs": "чулуун шат",
  "block.minecraft.smooth_sandstone_stairs": "гөлгөр элсэн чулуун шат",
  "block.minecraft.smooth_quartz_stairs": "гөлгөр кварц шат",
  "block.minecraft.granite_stairs": "боржин шат",
  "block.minecraft.andesite_stairs": "андезит шат",
  "block.minecraft.red_nether_brick_stairs": "улаан тамын тоосгон шат",
  "block.minecraft.polished_andesite_stairs": "өнгөлсөн андезит шат",
  "block.minecraft.diorite_stairs": "диорит шат",
  "block.minecraft.polished_granite_slab": "өнгөлсөн боржин хавтан",
  "block.minecraft.smooth_red_sandstone_slab": "гөлгөр улаан элсэн чулуун хавтан",
  "block.minecraft.mossy_stone_brick_slab": "хөвдтэй чулуун тоосгон хавтан",
  "block.minecraft.polished_diorite_slab": "өнгөлсөн диорит хавтан",
  "block.minecraft.mossy_cobblestone_slab": "хөвдтэй хагархай чулуун хавтан",
  "block.minecraft.end_stone_brick_slab": "ээндийн чулуун тоосгон хавтан",
  "block.minecraft.smooth_sandstone_slab": "гөлгөр элсэн чулуун хавтан",
  "block.minecraft.smooth_quartz_slab": "гөлгөр кварц хавтан",
  "block.minecraft.granite_slab": "боржин хавтан",
  "block.minecraft.andesite_slab": "андезит хавтан",
  "block.minecraft.red_nether_brick_slab": "улаан тамын тоосгон хавтан",
  "block.minecraft.polished_andesite_slab": "өнгөлсөн андезит хавтан",
  "block.minecraft.diorite_slab": "диорит хавтан",
  "block.minecraft.scaffolding": "барилгын шат",
  "block.minecraft.iron_door": "төмөр хаалга",
  "block.minecraft.oak_door": "царс модон хаалга",
  "block.minecraft.spruce_door": "гацуур модон хаалга",
  "block.minecraft.birch_door": "хус модон хаалга",
  "block.minecraft.jungle_door": "ширэнгэн ойн модон хаалга",
  "block.minecraft.acacia_door": "хуайс модон хаалга",
  "block.minecraft.dark_oak_door": "хар царс модон хаалга",
  "block.minecraft.crimson_door": "нөжит модон хаалга",
  "block.minecraft.warped_door": "гажуудсан модон хаалга",
  "block.minecraft.repeater": "редстоун давтагч",
  "block.minecraft.comparator": "редстоун харьцуулагч",
  "block.minecraft.structure_block": "байгууламжийн блок",
  "block.minecraft.jigsaw": "эвлүүлдэг блок",
  "item.minecraft.turtle_helmet": "яст мэлхийн хуяг□□толгойд байх үед:□+2 хуяг",
  "item.minecraft.scute": "яст мэлхийн хуягны хэлтэрхий",
  "item.minecraft.iron_shovel": "төмөр хүрз□□үндсэн гарт байх үед:□+3.5 дайрах хүч□-3 дайрах хурд",
  "item.minecraft.iron_pickaxe": "төмөр ёотуу□□үндсэн гарт байх үед:□+3 дайрах хүч□-2.8 дайрах хурд",
  "item.minecraft.iron_axe": "төмөр сүх□□үндсэн гарт байх үед:□+8 дайрах хүч□-3.1 дайрах хурд",
  "item.minecraft.flint_and_steel": "цахиур төмөр",
  "item.minecraft.apple": "алим",
  "item.minecraft.bow": "нум",
  "item.minecraft.arrow": "сум",
  "item.minecraft.coal": "нүүрс",
  "item.minecraft.charcoal": "модны нүүрс",
  "item.minecraft.diamond": "алмаас эрдэнэ",
  "item.minecraft.iron_ingot": "төмөр",
  "item.minecraft.gold_ingot": "алт",
  "item.minecraft.netherite_ingot": "недерит",
  "item.minecraft.netherite_scrap": "недеритийн хэлтэрхий",
  "item.minecraft.iron_sword": "төмөр сэлэм□□үндсэн гарт байх үед:□+5 дайрах хүч□-2.4 дайрах хурд",
  "item.minecraft.wooden_sword": "модон сэлэм□□үндсэн гарт байх үед:□+3 дайрах хүч□-2.4 дайрах хурд",
  "item.minecraft.wooden_shovel": "модон хүрз□□үндсэн гарт байх үед:□+1.5 дайрах хүч□-3 дайрах хурд",
  "item.minecraft.wooden_pickaxe": "модон ёотуу□□үндсэн гарт байх үед:□+1 дайрах хүч□-2.8 дайрах хурд",
  "item.minecraft.wooden_axe": "модон сүх□□үндсэн гарт байх үед:□+6 дайрах хүч□-3.2 дайрах хурд",
  "item.minecraft.stone_sword": "чулуун сэлэм□□үндсэн гарт байх үед:□+4 дайрах хүч□-2.4 дайрах хурд",
  "item.minecraft.stone_shovel": "чулуун хүрз□□үндсэн гарт байх үед:□+2.5 дайрах хүч□-3 дайрах хурд",
  "item.minecraft.stone_pickaxe": "чулуун ёотуу□□үндсэн гарт байх үед:□+2 дайрах хүч□-2.8 дайрах хурд",
  "item.minecraft.stone_axe": "чулуун сүх□□үндсэн гарт байх үед:□+8 дайрах хүч□-3.2 дайрах хурд",
  "item.minecraft.diamond_sword": "алмаасан сэлэм□□үндсэн гарт байх үед:□+6 дайрах хүч□-2.4 дайрах хурд",
  "item.minecraft.diamond_shovel": "алмаасан хүрз□□үндсэн гарт байх үед:□+4.5 дайрах хүч□-3 дайрах хурд",
  "item.minecraft.diamond_pickaxe": "алмаасан ёотуу□□үндсэн гарт байх үед:□+4 дайрах хүч□-2.8 дайрах хурд",
  "item.minecraft.diamond_axe": "алмаасан сүх□□үндсэн гарт байх үед:□+8 дайрах хүч□-3 дайрах хурд",
  "item.minecraft.stick": "савх",
  "item.minecraft.bowl": "аяга",
  "item.minecraft.mushroom_stew": "мөөгтэй шөл",
  "item.minecraft.golden_sword": "алтан сэлэм□□үндсэн гарт байх үед:□+3 дайрах хүч□-2.4 дайрах хурд",
  "item.minecraft.golden_shovel": "алтан хүрз□□үндсэн гарт байх үед:□+1.5 дайрах хүч□-3 дайрах хурд",
  "item.minecraft.golden_pickaxe": "алтан ёотуу□□үндсэн гарт байх үед:□+1 дайрах хүч□-2.8 дайрах хурд",
  "item.minecraft.golden_axe": "алтан сүх□□үндсэн гарт байх үед:□+6 дайрах хүч□-3 дайрах хурд",
  "item.minecraft.netherite_sword": "недерит сэлэм□□үндсэн гарт байх үед:□+7 дайрах хүч□-2.4 дайрах хурд",
  "item.minecraft.netherite_shovel": "недерит хүрз□□үндсэн гарт байх үед:□+5.5 дайрах хүч□-3 дайрах хурд",
  "item.minecraft.netherite_pickaxe": "недерит ёотуу□□үндсэн гарт байх үед:□+5 дайрах хүч□-2.8 дайрах хурд",
  "item.minecraft.netherite_axe": "недерит сүх□□үндсэн гарт байх үед:□+9 дайрах хүч□-3 дайрах хурд",
  "item.minecraft.string": "утас",
  "item.minecraft.feather": "өд",
  "item.minecraft.gunpowder": "дарь",
  "item.minecraft.wooden_hoe": "модон зээтүү□□үндсэн гарт байх үед:□-3 дайрах хурд",
  "item.minecraft.stone_hoe": "чулуун зээтүү□□үндсэн гарт байх үед:□-2 дайрах хурд",
  "item.minecraft.iron_hoe": "төмөр зээтүү□□үндсэн гарт байх үед:□-1 дайрах хурд",
  "item.minecraft.diamond_hoe": "алмаасан зээтүү□□үндсэн гарт байх үед:",
  "item.minecraft.golden_hoe": "алтан зээтүү□□үндсэн гарт байх үед:□-3 дайрах хурд",
  "item.minecraft.netherite_hoe": "недерит зээтүү□□үндсэн гарт байх үед:",
  "item.minecraft.wheat_seeds": "улаан буудайн үр",
  "item.minecraft.wheat": "улаан буудай",
  "item.minecraft.bread": "талх",
  "item.minecraft.leather_helmet": "арьсан малгай□□толгойд байх үед:□+1 хуяг",
  "item.minecraft.leather_chestplate": "арьсан цамц□□цээжинд байх үед:□+3 хуяг",
  "item.minecraft.leather_leggings": "арьсан өмд□□хөлөнд байх үед:□+2 хуяг",
  "item.minecraft.leather_boots": "арьсан гутал□□уланд байх үед:□+1 хуяг",
  "item.minecraft.chainmail_helmet": "гинжин малгай□□толгойд байх үед:□+2 хуяг",
  "item.minecraft.chainmail_chestplate": "гинжин цамц□□цээжинд байх үед:□+5 хуяг",
  "item.minecraft.chainmail_leggings": "гинжин өмд□□хөлөнд байх үед:□+4 хуяг",
  "item.minecraft.chainmail_boots": "гинжин гутал□□уланд байх үед:□+1 хуяг",
  "item.minecraft.iron_helmet": "төмөр малгай□□толгойд байх үед:□+2 хуяг",
  "item.minecraft.iron_chestplate": "төмөр цамц□□цээжинд байх үед:□+6 хуяг",
  "item.minecraft.iron_leggings": "төмөр өмд□□хөлөнд байх үед:□+5 хуяг",
  "item.minecraft.iron_boots": "төмөр гутал□□уланд байх үед:□+2 хуяг",
  "item.minecraft.diamond_helmet": "алмаасан малгай□□толгойд байх үед:□+3 хуяг□+2 хатуулаг",
  "item.minecraft.diamond_chestplate": "алмаасан цамц□□цээжинд байх үед:□+8 хуяг□+2 хатуулаг",
  "item.minecraft.diamond_leggings": "алмаасан өмд□□хөлөнд байх үед:□+6 хуяг□+2 хатуулаг",
  "item.minecraft.diamond_boots": "алмаасан гутал□□уланд байх үед:□+3 хуяг□+2 хатуулаг",
  "item.minecraft.golden_helmet": "алтан малгай□□толгойд байх үед:□+2 хуяг",
  "item.minecraft.golden_chestplate": "алтан цамц□□цээжинд байх үед:□+5 хуяг",
  "item.minecraft.golden_leggings": "алтан өмд□□хөлөнд байх үед:□+3 хуяг",
  "item.minecraft.golden_boots": "алтан гутал□□уланд байх үед:□+1 хуяг",
  "item.minecraft.netherite_helmet": "недерит малгай□□толгойд байх үед:□+3 хуяг□+3 хатуулаг□+1 түлхэлт эсэргүүцэх",
  "item.minecraft.netherite_chestplate": "недерит цамц□□цээжинд байх үед:□+8 хуяг□+3 хатуулаг□+1 түлхэлт эсэргүүцэх",
  "item.minecraft.netherite_leggings": "недерит өмд□□хөлөнд байх үед:□+6 хуяг□+3 хатуулаг□+1 түлхэлт эсэргүүцэх",
  "item.minecraft.netherite_boots": "недерит гутал□□уланд байх үед:□+3 хуяг□+3 хатуулаг□+1 түлхэлт эсэргүүцэх",
  "item.minecraft.flint": "цахиур",
  "item.minecraft.porkchop": "түүхий гахайн мах",
  "item.minecraft.cooked_porkchop": "шарсан гахайн мах",
  "item.minecraft.painting": "уран зураг",
  "item.minecraft.golden_apple": "алтан алим",
  "item.minecraft.enchanted_golden_apple": "шидэт алтан алим",
  "block.minecraft.oak_sign": "царс модон самбар",
  "block.minecraft.spruce_sign": "гацуур модон самбар",
  "block.minecraft.birch_sign": "хус модон самбар",
  "block.minecraft.jungle_sign": "ширэнгэн ойн модон самбар",
  "block.minecraft.acacia_sign": "хуайс модон самбар",
  "block.minecraft.dark_oak_sign": "хар царс модон самбар",
  "block.minecraft.crimson_sign": "нөжит модон самбар",
  "block.minecraft.warped_sign": "гажуудсан модон самбар",
  "item.minecraft.bucket": "хувин",
  "item.minecraft.water_bucket": "устай хувин",
  "item.minecraft.lava_bucket": "хайлмагтай хувин",
  "item.minecraft.minecart": "уурхайн тэрэг",
  "item.minecraft.saddle": "эмээл",
  "item.minecraft.redstone": "редстоуны тоос",
  "item.minecraft.snowball": "цасан бөмбөг",
  "item.minecraft.oak_boat": "царс модон завь",
  "item.minecraft.leather": "арьс",
  "item.minecraft.milk_bucket": "сүүтэй хувин",
  "item.minecraft.pufferfish_bucket": "үлээгч загастай хувин",
  "item.minecraft.salmon_bucket": "яргай загастай хувин",
  "item.minecraft.cod_bucket": "сагамхай загастай хувин",
  "item.minecraft.tropical_fish_bucket": "халуун орны загастай хувин",
  "item.minecraft.brick": "тоосго",
  "item.minecraft.clay_ball": "шавар бөмбөг",
  "block.minecraft.dried_kelp_block": "хатаасан замган блок",
  "item.minecraft.paper": "цаас",
  "item.minecraft.book": "ном",
  "item.minecraft.slime_ball": "салс бөмбөг",
  "item.minecraft.chest_minecart": "авдартай тэрэг",
  "item.minecraft.furnace_minecart": "зуухтай тэрэг",
  "item.minecraft.egg": "өндөг",
  "item.minecraft.compass": "луужин",
  "item.minecraft.fishing_rod": "загасны уурга",
  "item.minecraft.clock": "цаг",
  "item.minecraft.glowstone_dust": "гэрэлт тоос",
  "item.minecraft.cod": "түүхий сагамхай загас",
  "item.minecraft.salmon": "түүхий яргай загас",
  "item.minecraft.tropical_fish": "халуун орны загас",
  "item.minecraft.pufferfish": "үлээгч загас",
  "item.minecraft.cooked_cod": "шарсан сагамхай загас",
  "item.minecraft.cooked_salmon": "шарсан яргай загас",
  "item.minecraft.ink_sac": "бэх",
  "item.minecraft.red_dye": "улаан будаг",
  "item.minecraft.green_dye": "ногоон будаг",
  "item.minecraft.cocoa_beans": "какаоны шош",
  "item.minecraft.lapis_lazuli": "номин чулуу",
  "item.minecraft.purple_dye": "нил ягаан будаг",
  "item.minecraft.cyan_dye": "цэнхэр будаг",
  "item.minecraft.light_gray_dye": "цайвар саарал будаг",
  "item.minecraft.gray_dye": "саарал будаг",
  "item.minecraft.pink_dye": "цайвар ягаан будаг",
  "item.minecraft.lime_dye": "цайвар ногоон будаг",
  "item.minecraft.yellow_dye": "шар будаг",
  "item.minecraft.light_blue_dye": "цэнхэр будаг",
  "item.minecraft.magenta_dye": "ягаан будаг",
  "item.minecraft.orange_dye": "улбар шар будаг",
  "item.minecraft.bone_meal": "нунтагласан яс",
  "item.minecraft.blue_dye": "хөх будаг",
  "item.minecraft.brown_dye": "бор будаг",
  "item.minecraft.black_dye": "хар будаг",
  "item.minecraft.white_dye": "цагаан будаг",
  "item.minecraft.bone": "яс",
  "item.minecraft.sugar": "элсэн чихэр",
  "block.minecraft.cake": "бялуу",
  "block.minecraft.white_bed": "цагаан ор",
  "block.minecraft.orange_bed": "улбар шар ор",
  "block.minecraft.magenta_bed": "ягаан ор",
  "block.minecraft.light_blue_bed": "цайвар цэнхэр ор",
  "block.minecraft.yellow_bed": "шар ор",
  "block.minecraft.lime_bed": "цайвар ногоон ор",
  "block.minecraft.pink_bed": "ягаан ор",
  "block.minecraft.gray_bed": "саарал ор",
  "block.minecraft.light_gray_bed": "цайвар саарал ор",
  "block.minecraft.cyan_bed": "цэнхэр ор",
  "block.minecraft.purple_bed": "нил ягаан ор",
  "block.minecraft.blue_bed": "хөх ор",
  "block.minecraft.brown_bed": "бор ор",
  "block.minecraft.green_bed": "ногоон ор",
  "block.minecraft.red_bed": "улаан ор",
  "block.minecraft.black_bed": "хар ор",
  "item.minecraft.cookie": "жигнэмэг",
  "item.minecraft.filled_map": "газрын зураг□#0",
  "item.minecraft.shears": "хайч",
  "item.minecraft.melon_slice": "зүсэм тарвас",
  "item.minecraft.dried_kelp": "хатаасан замаг",
  "item.minecraft.pumpkin_seeds": "хулууны үр",
  "item.minecraft.melon_seeds": "тарвасны үр",
  "item.minecraft.beef": "түүхий үхрийн мах",
  "item.minecraft.cooked_beef": "шарсан үхрийн мах",
  "item.minecraft.chicken": "түүхий тахианы мах",
  "item.minecraft.cooked_chicken": "шарсан тахианы мах",
  "item.minecraft.rotten_flesh": "муудсан мах",
  "item.minecraft.ender_pearl": "ээндэрийн сувд",
  "item.minecraft.blaze_rod": "түймэрдэгчийн саваа",
  "item.minecraft.ghast_tear": "гастын нулимс",
  "item.minecraft.gold_nugget": "шижир алт",
  "item.minecraft.nether_wart": "тамын үү",
  "item.minecraft.potion": "гаргах боломжгүй ханд□үйлчилгээ байхгүй",
  "item.minecraft.glass_bottle": "лонх",
  "item.minecraft.spider_eye": "аалзны нүд",
  "item.minecraft.fermented_spider_eye": "исгэсэн аалзны нүд",
  "item.minecraft.blaze_powder": "түймэрдэгчийн нунтаг",
  "item.minecraft.magma_cream": "хайлмаган тос",
  "block.minecraft.brewing_stand": "ханд нэрэгч",
  "block.minecraft.cauldron": "тогоо",
  "item.minecraft.ender_eye": "ээндэрийн нүд",
  "item.minecraft.glistering_melon_slice": "гялтагнадаг зүсэм тарвас",
  "item.minecraft.bat_spawn_egg": "сарьсан багваахай төрүүлэх өндөг",
  "item.minecraft.bee_spawn_egg": "зөгий төрүүлэх өндөг",
  "item.minecraft.blaze_spawn_egg": "түймэрдэгч төрүүлэх өндөг",
  "item.minecraft.cat_spawn_egg": "муур төрүүлэх өндөг",
  "item.minecraft.cave_spider_spawn_egg": "агуйн аалз төрүүлэх өндөг",
  "item.minecraft.chicken_spawn_egg": "тахиа төрүүлэх өндөг",
  "item.minecraft.cod_spawn_egg": "сагамхай загас төрүүлэх өндөр",
  "item.minecraft.cow_spawn_egg": "үхэр төрүүлэх өндөг",
  "item.minecraft.creeper_spawn_egg": "крипер төрүүлэх өндөг",
  "item.minecraft.dolphin_spawn_egg": "далайн гахай төрүүлэх өндөг",
  "item.minecraft.donkey_spawn_egg": "илжиг төрүүлэх өндөг",
  "item.minecraft.drowned_spawn_egg": "тэнгисийн зомби төрүүлэх өндөг",
  "item.minecraft.elder_guardian_spawn_egg": "ахмад хамгаалагч төрүүлэх өндөг",
  "item.minecraft.enderman_spawn_egg": "ээндийн хүн төрүүлэх өндөг",
  "item.minecraft.endermite_spawn_egg": "ээндийн хачиг төрүүлэх",
  "item.minecraft.evoker_spawn_egg": "сүнс дуудагч төрүүлэх өндөг",
  "item.minecraft.fox_spawn_egg": "үнэг төрүүлэх өндөг",
  "item.minecraft.ghast_spawn_egg": "гаст төрүүлэх өндөг",
  "item.minecraft.guardian_spawn_egg": "хамгаалагч төрүүлэх өндөг",
  "item.minecraft.hoglin_spawn_egg": "хоглин төрүүлэх өндөг",
  "item.minecraft.horse_spawn_egg": "морь төрүүлэх өндөг",
  "item.minecraft.husk_spawn_egg": "хатсан зомби төрүүлэх өндөг",
  "item.minecraft.llama_spawn_egg": "тэмээн гөрөөс төрүүлэх өндөг",
  "item.minecraft.magma_cube_spawn_egg": "хайлмаган куб төрүүлэх өндөг",
  "item.minecraft.mooshroom_spawn_egg": "мүүшрүүм төрүүлэх өндөг",
  "item.minecraft.mule_spawn_egg": "луус төрүүлэх өндөг",
  "item.minecraft.ocelot_spawn_egg": "ирвэс төрүүлэх өндөг",
  "item.minecraft.panda_spawn_egg": "хулсны баавгай төрүүлэх өндөг",
  "item.minecraft.parrot_spawn_egg": "тоть төрүүлэх өндөг",
  "item.minecraft.phantom_spawn_egg": "фантом төрүүлэх өндөг",
  "item.minecraft.pig_spawn_egg": "гахай төрүүлэх өндөг",
  "item.minecraft.piglin_spawn_egg": "пиглин төрүүлэх өндөг",
  "item.minecraft.pillager_spawn_egg": "дээрэмчин төрүүлэх өндөг",
  "item.minecraft.polar_bear_spawn_egg": "цагаан баавгай төрүүлэх өндөг",
  "item.minecraft.pufferfish_spawn_egg": "үлээгч загас төрүүлэх",
  "item.minecraft.rabbit_spawn_egg": "туулай төрүүлэх өндөг",
  "item.minecraft.ravager_spawn_egg": "сүйтгэгч төрүүлэх өндөг",
  "item.minecraft.salmon_spawn_egg": "яргай загас төрүүлэх өндөг",
  "item.minecraft.sheep_spawn_egg": "хонь төрүүлэх өндөг",
  "item.minecraft.shulker_spawn_egg": "шалкер төрүүлэх өндөг",
  "item.minecraft.silverfish_spawn_egg": "жоом төрүүлэх өндөг",
  "item.minecraft.skeleton_spawn_egg": "араг яс төрүүлэх өндөг",
  "item.minecraft.skeleton_horse_spawn_egg": "араг ясан морь төрүүлэх өндөг",
  "item.minecraft.slime_spawn_egg": "салстан төрүүлэх өндөг",
  "item.minecraft.spider_spawn_egg": "аалз төрүүлэх өндөг",
  "item.minecraft.squid_spawn_egg": "наймаалж төрүүлэх өндөг",
  "item.minecraft.stray_spawn_egg": "тэнүүчлэгч төрүүлэх өндөг",
  "item.minecraft.strider_spawn_egg": "хайлмалхагч төрүүлэх өндөг",
  "item.minecraft.trader_llama_spawn_egg": "худалдаачны тэмээн гөрөөс төрүүлэх өндөн",
  "item.minecraft.tropical_fish_spawn_egg": "халуун орны загас төрүүлэх",
  "item.minecraft.turtle_spawn_egg": "яст мэлхий төрүүлэх өндөг",
  "item.minecraft.vex_spawn_egg": "залхаагч төрүүлэх өндөг",
  "item.minecraft.villager_spawn_egg": "тосгоны иргэн төрүүлэх өндөг",
  "item.minecraft.vindicator_spawn_egg": "дагалдагч төрүүлэх өндөг",
  "item.minecraft.wandering_trader_spawn_egg": "аялагч худалдаачин төрүүлэх өндөг",
  "item.minecraft.witch_spawn_egg": "шулам төрүүлэх өндөг",
  "item.minecraft.wither_skeleton_spawn_egg": "витер араг яс төрүүлэх өндөг",
  "item.minecraft.wolf_spawn_egg": "чоно төрүүлэх өндөг",
  "item.minecraft.zoglin_spawn_egg": "зоглин төрүүлэх өндөг",
  "item.minecraft.zombie_spawn_egg": "зомби төрүүлэх өндөг",
  "item.minecraft.zombie_horse_spawn_egg": "зомби морь төрүүлэх өндөг",
  "item.minecraft.zombie_villager_spawn_egg": "зомби тосгоны иргэн төрүүлэх өндөг",
  "item.minecraft.zombified_piglin_spawn_egg": "зомбижсон пиглин төрүүлэх өндөг",
  "item.minecraft.experience_bottle": "ид шидтэй лонх",
  "item.minecraft.fire_charge": "галт бөмбөг",
  "item.minecraft.writable_book": "ном болон үзэг",
  "item.minecraft.written_book": "бичсэн ном",
  "item.minecraft.emerald": "маргад эрдэнэ",
  "item.minecraft.item_frame": "эд зүйлийн хүрээ",
  "block.minecraft.flower_pot": "цэцгийн сав",
  "item.minecraft.carrot": "лууван",
  "item.minecraft.potato": "төмс",
  "item.minecraft.baked_potato": "шарсан төмс",
  "item.minecraft.poisonous_potato": "хортой төмс",
  "item.minecraft.map": "хоосон газрын зураг",
  "item.minecraft.golden_carrot": "алтан лууван",
  "block.minecraft.skeleton_skull": "гавлын яс",
  "block.minecraft.wither_skeleton_skull": "витерийн гавлын яс",
  "block.minecraft.player_head": "тоглогчийн толгой",
  "block.minecraft.zombie_head": "зомбины толгой",
  "block.minecraft.creeper_head": "криперийн толгой",
  "block.minecraft.dragon_head": "лууны толгой",
  "item.minecraft.carrot_on_a_stick": "лууван зүүсэн уурга",
  "item.minecraft.warped_fungus_on_a_stick": "гажуудсан мөөгтэй уурга",
  "item.minecraft.nether_star": "тамын од",
  "item.minecraft.pumpkin_pie": "хулууны бялуу",
  "item.minecraft.firework_rocket": "галт пуужин",
  "item.minecraft.firework_star": "галт од",
  "item.minecraft.enchanted_book": "шидэт ном",
  "item.minecraft.nether_brick": "тамын тоосго",
  "item.minecraft.quartz": "кварц",
  "item.minecraft.tnt_minecart": "tnt-тэй тэрэг",
  "item.minecraft.hopper_minecart": "гулгуулагчтай тэрэг",
  "item.minecraft.prismarine_shard": "присмарины хэлтэрхий",
  "item.minecraft.prismarine_crystals": "присмарины талст",
  "item.minecraft.rabbit": "түүхийн туулайн мах",
  "item.minecraft.cooked_rabbit": "шарсан туулайн мах",
  "item.minecraft.rabbit_stew": "туулайн шөл",
  "item.minecraft.rabbit_foot": "туулайн хөл",
  "item.minecraft.rabbit_hide": "туулайн арьс",
  "item.minecraft.armor_stand": "хувцасны өлгүүр",
  "item.minecraft.iron_horse_armor": "морины төмөр хуяг",
  "item.minecraft.golden_horse_armor": "морины алтан хуяг",
  "item.minecraft.diamond_horse_armor": "морины алмаасан хуяг",
  "item.minecraft.leather_horse_armor": "морины арьсан хуяг",
  "item.minecraft.lead": "уяа",
  "item.minecraft.name_tag": "нэрийн шошго",
  "item.minecraft.command_block_minecart": "тушаалын блоктой тэрэг",
  "item.minecraft.mutton": "түүхий хонины мах",
  "item.minecraft.cooked_mutton": "шарсан хонины мах",
  "block.minecraft.white_banner": "цагаан туг",
  "block.minecraft.orange_banner": "улбар шар туг",
  "block.minecraft.magenta_banner": "ягаан туг",
  "block.minecraft.light_blue_banner": "цайвар цэнхэр туг",
  "block.minecraft.yellow_banner": "шар туг",
  "block.minecraft.lime_banner": "цайвар ногоон туг",
  "block.minecraft.pink_banner": "цайвар ягаан туг",
  "block.minecraft.gray_banner": "саарал туг",
  "block.minecraft.light_gray_banner": "цайвар саарал туг",
  "block.minecraft.cyan_banner": "цэнхэр туг",
  "block.minecraft.purple_banner": "нил ягаан туг",
  "block.minecraft.blue_banner": "хөх туг",
  "block.minecraft.brown_banner": "бор туг",
  "block.minecraft.green_banner": "ногоон туг",
  "block.minecraft.red_banner": "улаан туг",
  "block.minecraft.black_banner": "хар туг",
  "item.minecraft.end_crystal": "ээндийн талст",
  "item.minecraft.chorus_fruit": "дахилтат жимс",
  "item.minecraft.popped_chorus_fruit": "хөөсөн дахилтат жимс",
  "item.minecraft.beetroot": "улаан манжин",
  "item.minecraft.beetroot_seeds": "улаан манжингийн үр",
  "item.minecraft.beetroot_soup": "улаан манжингийн шөл",
  "item.minecraft.dragon_breath": "лууны амьсгал",
  "item.minecraft.splash_potion": "шиддэг гаргах боломжгүй ханд□үйлчилгээ байхгүй",
  "item.minecraft.spectral_arrow": "тодруулагч сум",
  "item.minecraft.tipped_arrow": "урлах боломжгүй хандтай сум□үйлчилгээ байхгүй",
  "item.minecraft.lingering_potion": "ууршимтгай гаргах боломжгүй ханд□үйлчилгээ байхгүй",
  "item.minecraft.shield": "бамбай",
  "item.minecraft.elytra": "далавч",
  "item.minecraft.spruce_boat": "гацуур модон завь",
  "item.minecraft.birch_boat": "хус модон завь",
  "item.minecraft.jungle_boat": "ширэнгэн ойн модон завь",
  "item.minecraft.acacia_boat": "хуайс модон завь",
  "item.minecraft.dark_oak_boat": "хар царс модон завь",
  "item.minecraft.totem_of_undying": "үхэшгүй мөнхийн сахиус",
  "item.minecraft.shulker_shell": "шалкерийн хуяг",
  "item.minecraft.iron_nugget": "төмрийн хэлтэрхий",
  "item.minecraft.knowledge_book": "мэдлэгийн ном",
  "item.minecraft.debug_stick": "шалгах саваа",
  "item.minecraft.music_disc_13": "пянз□c418 - 13",
  "item.minecraft.music_disc_cat": "пянз□c418 - cat",
  "item.minecraft.music_disc_blocks": "пянз□c418 - blocks",
  "item.minecraft.music_disc_chirp": "пянз□c418 - chirp",
  "item.minecraft.music_disc_far": "пянз□c418 - far",
  "item.minecraft.music_disc_mall": "пянз□c418 - mall",
  "item.minecraft.music_disc_mellohi": "пянз□c418 - mellohi",
  "item.minecraft.music_disc_stal": "пянз□c418 - stal",
  "item.minecraft.music_disc_strad": "пянз□c418 - strad",
  "item.minecraft.music_disc_ward": "пянз□c418 - ward",
  "item.minecraft.music_disc_11": "пянз□c418 - 11",
  "item.minecraft.music_disc_wait": "пянз□c418 - wait",
  "item.minecraft.music_disc_pigstep": "пянз□лена рэйн - pigstep",
  "item.minecraft.trident": "сэрээ таяг□□үндсэн гарт байх үед:□+8 дайрах хүч□-2.9 дайрах хурд",
  "item.minecraft.phantom_membrane": "фантомын хальс",
  "item.minecraft.nautilus_shell": "дунгийн яс",
  "item.minecraft.heart_of_the_sea": "тэнгисийн зүрх",
  "item.minecraft.crossbow": "хулгавч нум",
  "item.minecraft.suspicious_stew": "сэжигтэй шөл",
  "block.minecraft.loom": "нэхмэлийн машин",
  "item.minecraft.flower_banner_pattern": "тугны хэв□цэцэг",
  "item.minecraft.creeper_banner_pattern": "тугны хэв□криперийн нүүр",
  "item.minecraft.skull_banner_pattern": "тугны хэв□гавлын яс",
  "item.minecraft.mojang_banner_pattern": "тугны хэв□зүйл",
  "item.minecraft.globe_banner_pattern": "тугны хэв□бөмбөрцөг",
  "item.minecraft.piglin_banner_pattern": "тугны хэв□хоншоор",
  "block.minecraft.composter": "бордооны торх",
  "block.minecraft.barrel": "торх",
  "block.minecraft.smoker": "утагч",
  "block.minecraft.blast_furnace": "хайлуулах зуух",
  "block.minecraft.cartography_table": "зураг зүйн ширээ",
  "block.minecraft.fletching_table": "нум сум урлах ширээ",
  "block.minecraft.grindstone": "билүү",
  "block.minecraft.lectern": "индэр",
  "block.minecraft.smithing_table": "дархны ширээ",
  "block.minecraft.stonecutter": "чулуу зүсэгч",
  "block.minecraft.bell": "хонх",
  "block.minecraft.lantern": "дэнлүү",
  "block.minecraft.soul_lantern": "сүнслэг дэнлүү",
  "item.minecraft.sweet_berries": "чихэрлэг жимсгэнэ",
  "block.minecraft.campfire": "түүдэг гал",
  "block.minecraft.soul_campfire": "сүнслэг түүдэг гал",
  "block.minecraft.shroomlight": "мөөгний гэрэл",
  "item.minecraft.honeycomb": "зөгийн сархинаг",
  "block.minecraft.bee_nest": "зөгийн үүр",
  "block.minecraft.beehive": "зөгийн үүр",
  "item.minecraft.honey_bottle": "шилтэй зөгийн бал",
  "block.minecraft.honey_block": "зөгийн балан блок",
  "block.minecraft.honeycomb_block": "зөгийн сархинаган блок",
  "block.minecraft.lodestone": "чиглүүлэгч чулуу",
  "block.minecraft.netherite_block": "недерит блок",
  "block.minecraft.ancient_debris": "эртний металл",
  "block.minecraft.target": "бай",
  "block.minecraft.crying_obsidian": "уйлж буй хар шил",
  "block.minecraft.blackstone": "хар чулуу",
  "block.minecraft.blackstone_slab": "хар чулуун хавтан",
  "block.minecraft.blackstone_stairs": "хар чулуун шат",
  "block.minecraft.gilded_blackstone": "алтадсан хар чулуу",
  "block.minecraft.polished_blackstone": "өнгөлсөн хар чулуу",
  "block.minecraft.polished_blackstone_slab": "өнгөлсөн хар чулуун хавтан",
  "block.minecraft.polished_blackstone_stairs": "өнгөлсөн хар чулуун шат",
  "block.minecraft.chiseled_polished_blackstone": "сийлбэртэй өнгөлсөн хар чулуу",
  "block.minecraft.polished_blackstone_bricks": "өнгөлсөн хар чулуун тоосго",
  "block.minecraft.polished_blackstone_brick_slab": "өнгөлсөн хар чулуун тоосгон хавтан",
  "block.minecraft.polished_blackstone_brick_stairs": "өнгөлсөн хар чулуун тоосгон шат",
  "block.minecraft.cracked_polished_blackstone_bricks": "хагархай өнгөлсөн хар чулуун тоосго",
  "block.minecraft.respawn_anchor": "дахин төрүүлэх зангуу",
}
export const mn_mn = items; 
